import TeamLabel from './TeamLabel';
import { Form, Table } from './';
import { formatName } from '../common';

import React from 'react';
//import PropTypes from 'prop-types';
import { get, without } from 'lodash';

const EntriesPicker = ({ name, value: values, options, onChange }) => {
  const rows = options.map(entry => ({
    key: entry.id,
    disabled: entry.disabled,
    value: entry.primaryKey,
    checked: values.includes(entry.primaryKey),
    entryTotal:
      entry.total || (entry.totalMinimum ? `(${entry.totalMinimum})` : ''),
    lotNumber: entry.lotNumber,
    teams: entry.teams,
    name: formatName(entry),
    groupLetter: get(entry.group, 'letter'),
  }));

  const onCheckboxChange = (event, { name: value, checked, ...rest }) =>
    onChange(event, {
      name,
      value: checked ? [...values, value] : without(values, value),
      ...rest,
    });

  return (
    <Table fixed singleLine compact>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width={1} />
          <Table.HeaderCell width={2}>Entry total</Table.HeaderCell>
          <Table.HeaderCell width={1}>Lot</Table.HeaderCell>
          <Table.HeaderCell width={2}>Team</Table.HeaderCell>
          <Table.HeaderCell>Name</Table.HeaderCell>
          <Table.HeaderCell width={2}>Group</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {rows.map(row => (
          <Table.Row key={row.key} disabled={row.disabled}>
            <Table.Cell>
              <Form.Checkbox
                name={row.value}
                checked={row.checked}
                onChange={onCheckboxChange}
              />
            </Table.Cell>
            <Table.Cell>{row.entryTotal}</Table.Cell>
            <Table.Cell>{row.lotNumber}</Table.Cell>
            <Table.Cell>
              {row.teams.map(team => (
                <TeamLabel key={team.id} team={team} />
              ))}
            </Table.Cell>
            <Table.Cell>{row.name}</Table.Cell>
            <Table.Cell>{row.groupLetter}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

/*
EntriesPicker.propTypes = {
  meta: PropTypes.shape({
    groups: PropTypes.array.isRequired,
  }).isRequired,
};
*/

export default EntriesPicker;



// WEBPACK FOOTER //
// ./src/components/EntriesPicker.js